import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import NumberDisplay from "../../../components/numberDisplay/numberDisplay";
import PercentageDisplay from "../../../components/percentageDisplay/percentageDisplay";
import PercentageGain from "../../../components/percentageGain/percentageGain";
import NoData from "../../../components/noData/noData";

export const Bookings = () => {
  const {
    data: {
      bookingsShowsPercent,
      bookingsShowsPercentRawDataLink,
      bookingsShowsPercentChange,
      introsBooked,
      introsBookedRawDataLink,
      introsBookedChange,
      classConversionRatePercentRawDataLink,
      classConversionRatePercent,
      classConversionRatePercentChange,
      bookingsShows,
      numberOfClassConversion
    },
    data
  } = useSelector((state) => state.studioInfo.introsBooked);

  if (data === null) {
    return (
      <div className="bookings-wrapper">
        <NoData />
      </div>
    );
  } else {
    return (
      <div className="bookings-wrapper">
        <div className="bookings-progress">
          <div className="arrow">
            ----------&nbsp;
            <span className="percentage-display-wrapper">
              <PercentageDisplay
                showDecimal
                size={30}
                value={(bookingsShowsPercent * 100).toFixed(1)}
                url={bookingsShowsPercentRawDataLink}
              />
            </span>
            &nbsp;----------
            <FontAwesomeIcon icon={faPlay} />
            <span className="percentage-gain-wrapper-arrow">
              <PercentageGain value={(bookingsShowsPercentChange * 100).toFixed(1)} />
            </span>
          </div>
          <h2 className="title">Intros Booked</h2>
          <span className="bookings-number-wrapper">
            <NumberDisplay value={introsBooked} url={introsBookedRawDataLink} />
            <span className="percentage-gain-wrapper">
              <PercentageGain
                value={(introsBookedChange * 100).toFixed(1)}
                url={classConversionRatePercentRawDataLink}
              />
            </span>
          </span>
        </div>
        <div className="bookings-progress">
          <div className="arrow">
            ----------&nbsp;
            <span className="percentage-display-wrapper">
              <PercentageDisplay
                showDecimal
                size={30}
                value={(classConversionRatePercent * 100).toFixed(1)}
                url={classConversionRatePercentRawDataLink}
              />
            </span>
            &nbsp;----------
            <FontAwesomeIcon icon={faPlay} />
            <span className="percentage-gain-wrapper-arrow">
              <PercentageGain value={(classConversionRatePercentChange * 100).toFixed(1)} />
            </span>
          </div>
          <h2 className="title">Booking Shows</h2>
          <span className="bookings-number-wrapper">
            <NumberDisplay size={46} value={bookingsShows} url={bookingsShowsPercentRawDataLink} />
          </span>
        </div>
        <div className="bookings-progress">
          <h2 className="title">Class Conversion</h2>
          <span className="bookings-number-wrapper">
            <NumberDisplay
              size={46}
              value={numberOfClassConversion}
              url={classConversionRatePercentRawDataLink}
            />
          </span>
        </div>
      </div>
    );
  }
};
